import { IconButton, List, ListItem, ListItemText, Typography } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import { TextColorStyleClasses } from 'assets/jss/common-styles';
import BoxDrawer from 'components/BoxDrawer';
import ButtonConfirmAndClose from 'components/Buttons/ButtonConfirmAndClose';
import IconThumbUp from 'components/Icons/IconThumbUp';
import IconUserSpecialist from 'components/Icons/IconUserSpecialist';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import { UserKnowsAboutSpecialistGrantMethod } from 'models/ApiEnums';
import { UserKnowsAboutGetDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    grantSpecialist?: boolean;
    grantEndorsement?: boolean;
}

interface IProps {
    knowsAbout: UserKnowsAboutGetDto;
    userName: string;
    onClose: (
        result: {
            grantSpecialist: boolean;
            grantEndorsement?: boolean;
        }
    ) => void;
}

type Props = IProps & WithStyles<typeof TextColorStyleClasses> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class UserManagerSpecialistDrawer extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            grantEndorsement: props.knowsAbout.currentEndorser != null,
            grantSpecialist: props.knowsAbout.specialist.specialistGrantMethod != UserKnowsAboutSpecialistGrantMethod.None
        };
    }

    ///
    private res(r: string) {
        return this.props.t("Views.User.Dialogs.UserManagerSpecialistDrawer." + r);
    }

    ///
    private renderForm() {
        const { userName, knowsAbout: { topicAllowUserSpecialist, endorserHandleSpecialist } } = this.props;
        const { grantSpecialist, grantEndorsement } = this.state;

        return (
            <div>
                <Typography variant="subtitle1"><b>{this.res("AssignToLabel")} {userName}:</b></Typography>

                <List >

                    <ListItem dense button
                        onClick={
                            () => {
                                this.setState({ grantEndorsement: grantEndorsement === null || grantEndorsement === false ? true : false });
                            }
                        }
                    >
                        <IconButton
                            color={grantEndorsement === true ? "primary" : "default"}
                            classes={{ colorPrimary: this.props.classes.info }}
                        >
                            <IconThumbUp />
                        </IconButton>
                        <ListItemText primary={this.res("EndorseText")} />
                    </ListItem>

                    {
                        topicAllowUserSpecialist &&
                        <ListItem
                            button
                            dense
                            disabled={!endorserHandleSpecialist}
                            onClick={
                                () => {
                                    this.setState({ grantSpecialist: !grantSpecialist });
                                }
                            }
                        >
                            <IconButton
                                color={grantSpecialist === true ? "primary" : "default"}
                                classes={{ colorPrimary: this.props.classes.success }}
                            >
                                <IconUserSpecialist
                                    active
                                />
                            </IconButton>
                            <ListItemText primary={this.res("ExpertTagText")} />
                        </ListItem>
                    }
                </List>

            </div>
        );
    }

    ///
    public render() {
        const { knowsAbout: { topicName }, onClose } = this.props;

        return (
            <BoxDrawer
                open
                onClose={() => { onClose(null); }}
                title={this.res("BoxTitle")}
                subtitle={topicName}
            >
                <MuiPaper dense elevation={0}>
                    {this.renderForm()}

                    <ButtonConfirmAndClose
                        fullWidth
                        onClick={
                            () => {
                                this.props.onClose(
                                    {
                                        grantSpecialist: this.state.grantSpecialist,
                                        grantEndorsement: this.state.grantEndorsement
                                    }
                                );
                            }
                        }
                    />
                </MuiPaper>
            </BoxDrawer>
        );
    }
}

export default withTranslation()(withStyles(TextColorStyleClasses)(UserManagerSpecialistDrawer));